<template>
    <div class="container-fluid py-5 bg-gris-renault">
        <div class="row align-items-center text-center">
            <div class="col-12 col-md-6 text-md-end">
                <span class="fw-600 separador-contacto d-none d-md-block"
                    >CONTACTO DE PRENSA</span
                >
                <div class="d-block d-md-none separador-contacto">
                    <span class="fw-600">CONTACTO DE PRENSA</span>
                </div>
            </div>
            <div class="col-12 col-md-6 text-center text-md-start pt-3 pt-md-0">
                <a
                    href="mailto:prensa.argentina@renault.com"
                    class="text-decoration-none text-dark"
                    >prensa.argentina@renault.com</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {

    },
};
</script>